import { atom } from 'jotai'

export const isPasswordModalOpenAtom = atom(false)